<template>
  <div class="modal-out">
    <div class="modal">
      <div class="modal-header">
        <div class="title">设置</div>
        <button type="button" class="btn-close" @click="closeSelf">X</button>
      </div>
      <div class="modal-body">

        <div style="padding: 0px 10px 10px 10px">
          <el-button type="primary" size="mini" @click="toggleModalAdd">添加手机号</el-button>

          <div style="float: right">

<!--            <el-button size="mini" type="primary" :loading="loadingVolume" @click="setVolume(3)">音量小</el-button>-->
<!--            <el-button size="mini" type="primary" :loading="loadingVolume" @click="setVolume(5)">音量大</el-button>-->
<!--            <el-button size="mini" type="success"  :loading="loadingPhone" @click="setPhone">同步手机号</el-button>-->

            <el-button size="mini" type="success" :loading="loadingPhone" @click="setPhone2">同步手机号</el-button>
          </div>
          <div style="clear: both;"></div>
        </div>

        <el-table class="table" size="mini" :data="tableData" v-loading="loading" border :height="300">
          <el-table-column label="姓名" prop="name" width="100"></el-table-column>
          <el-table-column label="手机号" prop="phone"></el-table-column>
          <el-table-column label="操作" width="100">
            <template slot-scope="scope">
              <el-button type="danger" size="mini" @click.native.prevent="handleDelete(scope.$index, scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>

      </div>

    </div>

    <AddPhone ref="myAddPhone" v-show="showModalAddPhone" v-on:closeAddPhone="showModalAddPhone=false" v-on:getListPhone="getListPhone"></AddPhone>

  </div>
</template>

<script>

import {timeStr} from "@/common/times";
import {hex_md5, hex_md5_with_china} from "@/common/Base64MD5";

import AddPhone from "./AddPhone"
import {getGovernmentCode} from "@/utils/auth";

export default {
  name: 'Add',
  data() {
    return {
      loading: false,

      loadingVolume: false,
      loadingPhone: false,

      showModalAddPhone:false,

      rules:{
        imei:[
          { required: true, message: '请输入Imei号', trigger: 'blur' },
        ],
        userName:[
          { required: true, message: '请选择老人', trigger: 'blur' }
        ],

      },

      tableData:[],
      deviceOWonCatCode:'',


    }
  },
  components: {
    AddPhone
  },
  methods: {
    init(deviceOWonCatCode){
      this.deviceOWonCatCode = deviceOWonCatCode;
      this.getListPhone();
    },
    closeSelf() {
      this.$emit("closeSet");
    },

    toggleModalAdd: function () {
      this.$refs.myAddPhone.init(this.deviceOWonCatCode);
      this.showModalAddPhone = !this.showModalAddPhone;
    },



    getListPhone(){

      var _this=this
      this.loading=true

      this.$axios({
        method: "post",
        url: this.$deviceUrl + "DeviceOWonCat/ListPhone",
        data: {
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
          deviceOWonCatCode:this.deviceOWonCatCode,

        },
      }).then((response) => {
        _this.loading=false
        if (response.data.error == 0) {
          this.tableData = response.data.data.list;

        } else if (response.data.error == 1) {
          this.$message.error(response.data.message);
        }
      }).catch(function (error) {
        _this.loading=false
        console.log(error);
      });
    },

    confirm(addForm){
      this.$refs[addForm].validate((valid) => {
        if(valid){
          this.addSubmit();
        }else {
          console.log('error submit!!');
          return false;
        }
      })

    },

    addSubmit(){

      if(this.loading){
        return;
      }else{
        this.loading = true;
      }

      this.addForm.sign = "";
      this.addForm.sign = hex_md5_with_china("jsonStr=" + JSON.stringify(this.addForm) + "&key="+this.$signKey)


      this.$axios({
        method: 'post',
        url: this.$deviceUrl+"DeviceOWonCat/Add",
        data: this.addForm
      }).then((response) => {
        this.loading = false;
        if (response.data.error == 0) {
          this.$emit("closeAdd");
          this.$emit("getList");
        }else if(response.data.error == 1){
          this.$message.error(response.data.message)
        }
      })

    },

    handleDelete(index,row) {
      this.$confirm("您确定要删除手机号吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {


        let dataForm = {
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
          deviceOWonCatPhoneCode: row.deviceOWonCatPhoneCode,
        };

        this.$axios({
          method: "post",
          url: this.$deviceUrl + "DeviceOWonCat/DeletePhone",
          data:dataForm,
        }).then((response) => {
          //console.log(response);
          if (response.data.error == 0) {
            //this.$message({message: "解绑成功", type: "success",});
            this.getListPhone();
          } else if (response.data.error == 1) {
            this.$message.error(response.data.message);
          }
        }).catch(function (error) {
          console.log(error);
        });
      }).catch(() => {
        //this.$message({type: "info", message: "已取消解绑",});
      });
    },



    setVolume(size){

      this.loadingVolume = true;

      this.$axios({
        method: "post",
        url: this.$deviceUrl + "DeviceOWonCat/SetVoice",
        data:{
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
          deviceOWonCatCode: this.deviceOWonCatCode,
          volume:size,
        },
      }).then((response) => {
        //console.log(response);
        this.loadingVolume = false;

        if (response.data.error == 0) {
          this.$message({message: "设置成功", type: "success",});
        } else if (response.data.error == 1) {
          this.$message.error(response.data.message);
        }

      }).catch(function (error) {
        console.log(error);
      });

    },
    setPhone(){

      this.loadingPhone = true;

      this.$axios({
        method: "post",
        url: this.$deviceUrl + "DeviceOWonCat/SetPhone",
        data:{
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
          deviceOWonCatCode: this.deviceOWonCatCode,
        },
      }).then((response) => {
        //console.log(response);
        this.loadingPhone = false;

        if (response.data.error == 0) {
          this.$message({message: "设置成功", type: "success",});
        } else if (response.data.error == 1) {
          this.$message.error(response.data.message);
        }

      }).catch(function (error) {
        console.log(error);
      });

    },


    setPhone2(){

      this.loadingPhone = true;

      let addForm={
        timeStr:timeStr,
        sign:'',
        deviceOWonCatCode: this.deviceOWonCatCode,
      };
      addForm.sign = "";
      addForm.sign = hex_md5_with_china("jsonStr=" + JSON.stringify(addForm) + "&key="+this.$signKey)

      this.$axios({
        method: 'post',
        url: this.$deviceUrl+"DeviceOWonCat/SetPhone2",
        data: addForm
      }).then((response) => {
        this.loadingPhone = false;
        if (response.data.error == 0) {
          this.$message({message: "设置成功", type: "success",});
        }else if(response.data.error == 1){
          this.$message.error(response.data.message)
        }
      })

    },



  }
}


</script>





<style lang="scss" scoped>

</style>
